import { __decorate } from 'tslib';
import { Service } from '../../decorators/class/service.js';
import { EventEmitter } from './event-emitter.js';

/**
 * 内部通知中心，空类是由于依赖的di不支持多个key绑定同一个构造
 * @internal
 */
let InternalEventEmitter = class InternalEventEmitter extends EventEmitter {
};
InternalEventEmitter = __decorate([
    Service()
], InternalEventEmitter);

export { InternalEventEmitter };
//# sourceMappingURL=internal-event-emitter.js.map
